import { Check } from 'lucide-react';

interface Step {
  number: number;
  title: string;
  description: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className='w-full py-8'>
      {/* Desktop - Horizontal */}
      <div className='hidden md:flex items-start justify-center gap-16 max-w-4xl mx-auto px-4'>
        {steps.map((step) => (
          <div key={step.number} className='flex flex-col items-center'>
            {/* Circle */}
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center font-bold text-lg transition-all duration-300 ${
                currentStep > step.number
                  ? 'bg-green-600 text-white'
                  : currentStep === step.number
                  ? 'bg-blue-900 text-white ring-4 ring-blue-200'
                  : 'bg-gray-300 text-gray-600'
              }`}
            >
              {currentStep > step.number ? (
                <Check className='w-8 h-8' />
              ) : (
                step.number
              )}
            </div>
            {/* Text */}
            <div className='mt-3 text-center w-32'>
              <p
                className={`text-xs font-bold uppercase tracking-wide transition-colors duration-300 ${
                  currentStep === step.number 
                    ? 'text-blue-900' 
                    : currentStep > step.number 
                    ? 'text-green-600' 
                    : 'text-gray-500'
                }`}
              >
                {step.title}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile - Vertical Compact */}
      <div className='md:hidden px-4'>
        <div className='flex items-center justify-between mb-4'>
          <span className='text-sm font-bold text-gray-700 uppercase'>
            Etapa {currentStep} de {steps.length}
          </span>
          <span className='text-xs text-gray-500'>
            {Math.round((currentStep / steps.length) * 100)}% concluído
          </span>
        </div>
        {/* Progress bar */}
        <div className='w-full bg-gray-300 rounded-full h-2.5'>
          <div
            className='bg-blue-900 h-2.5 rounded-full transition-all duration-300'
            style={{ width: `${(currentStep / steps.length) * 100}%` }}
          />
        </div>
        {/* Current step info */}
        <div className='mt-4 text-center'>
          <h3 className='text-base font-bold text-gray-900 uppercase tracking-wide'>
            {steps[currentStep - 1]?.title}
          </h3>
          <p className='text-sm text-gray-600 mt-1'>
            {steps[currentStep - 1]?.description}
          </p>
        </div>
      </div>
    </div>
  );
}
